<div class="auth-page-container">
    <div class="auth-card">
      <div class="auth-icon">
        <i class="ri-user-line"></i>
      </div>
      <h2 class="auth-title">Connexion</h2>

      <p class="welcome-text">
        Bienvenue sur ton espace <span class="hub-gradient">AfroTech Hub</span> !
      </p>      
    
      <form [formGroup]="logForm" (ngSubmit)="onLogin()" class="auth-form">
        <!-- Champ email -->
        <div class="form-group">
          <label>Adresse e-mail</label>
          <input
            type="email"
            class="form-control"
            placeholder="Adresse e-mail"
            formControlName="identifier"
          />
          <div *ngIf="logForm.get('identifier')?.touched">
            <div *ngIf="logForm.get('identifier')?.hasError('required')" class="text-danger small mt-1">
              L'adresse e-mail est requise.
            </div>
            <div *ngIf="logForm.get('identifier')?.hasError('email')" class="text-danger small mt-1">
              L'adresse e-mail n'est pas valide.
            </div>
          </div>                  
        </div>

        <!-- Champ mot de passe -->
        <div class="form-group">
          <label>Mot de passe</label>
          <input
            type="password"
            class="form-control"
            placeholder="Mot de passe"
            formControlName="password"
          />
          
        </div>
  
        <div class="text-end">
          <a class="forgot-link" routerLink="/forgot-password">Mot de passe oublié ?</a>
        </div>
  
        <button type="submit" class="btn btn-primary w-100 mt-3">Se connecter</button>
  
        <p class="signup-link text-center mt-3">
          Vous n’avez pas de compte ?
          <a routerLink="/sign-up">Inscrivez-vous</a>
        </p>
      </form>
    </div>
  </div>
  